"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { selectActiveGroupId, setActiveGroupId } from "@/store/groupSlice";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import NetworkPageLayoutApp from "./NetworkPageLayoutApp";
export default function NetworkPageLayout(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  const searchParams = useSearchParams();
  const activeGroupId = useSelector(selectActiveGroupId);
  const dispatch = useDispatch();
  const {
    isApp
  } = useDeviceInfo();
  const initRef = useRef(false);
  const [isReady, setIsReady] = useState(false);
  let t1;
  let t2;
  if ($[0] !== activeGroupId || $[1] !== dispatch || $[2] !== searchParams) {
    t1 = () => {
      if (!initRef.current) {
        initRef.current = true;
        const group = searchParams.get("group");
        if (group && group !== activeGroupId) {
          dispatch(setActiveGroupId(group));
        }
        setIsReady(true);
      }
    };
    t2 = [searchParams, activeGroupId, dispatch];
    $[0] = activeGroupId;
    $[1] = dispatch;
    $[2] = searchParams;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (isApp) {
    let t3;
    if ($[5] !== children) {
      t3 = <NetworkPageLayoutApp>{children}</NetworkPageLayoutApp>;
      $[5] = children;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  const t3 = isReady && children;
  let t4;
  if ($[7] !== t3) {
    t4 = <main className="tailwind-scope tw-overflow-x-hidden tw-bg-black"><div className="tailwind-scope tw-mx-auto tw-mt-6 tw-min-h-dvh tw-bg-black tw-pb-6 lg:tw-mt-8"><div className="tw-w-full"><div className="tw-mt-4 tw-px-3 lg:tw-px-6 xl:tw-px-8">{t3}</div></div></div></main>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}